export const PHONE_NUMBER_FORMATS = {
  Mobile: '### ### ###',
  Landline: '# #### ####',
  Default: '#########',
};
